import _ from 'underscore';
import { useEffect, useState, useCallback } from 'react';
import { FORM_STATES, FORM_EVENTS } from '../machine/machine-config';
import { isPromise } from './is-promise';

export const useDataSaver = ({ save, state, send }) => {
  const [isSaving, setIsSaving] = useState(false);
  const shouldSave = state.matches(FORM_STATES.SAVING);
  const currentData = _.get(state, ['context', 'data']);
  const isValid = _.get(state, ['context', 'isValid']);
  const initData = _.get(state, ['context', 'initialData']);

  const onDoneSaving = useCallback((data) => {
    send(FORM_EVENTS.DONE_SAVING, { data });
  }, [send]);

  const onFailedSaving = useCallback(({ data, initialData, error } = {}) => {
    send(FORM_EVENTS.FAILED_SAVING, { data, initialData, error });
  }, [send]);

  useEffect(() => {
    if (shouldSave && !isSaving) {
      if (!save) {
        onDoneSaving();
        return;
      }
      if (!isValid) {
        onFailedSaving();
        return;
      }
      setIsSaving(true);
      const res = save({
        data: currentData,
        initialData: initData,
        onComplete: onDoneSaving,
        onError: onFailedSaving,
      });
      if (isPromise(res)) {
        res.then(onDoneSaving).catch(onFailedSaving);
      }
    } else if (!shouldSave && isSaving) {
      setIsSaving(false);
    }
  }, [isSaving, save, onDoneSaving, onFailedSaving, shouldSave, currentData, initData, isValid]);
};
